import styled from '@emotion/styled'
import { BannerViewEnum } from '@pharmac-extranet/management-api'
import { ExtranetContainer, useBreakpoint, useLanguage } from '@pharmac-extranet/shared'
import { PharmacH3, PharmacLink } from '@pharmac/ui'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import {
  ExtranetCarousel,
  ExtranetCarouselImage,
  ExtranetCarouselItem,
} from '../../components/extranet/ExtranetCarousel'
import { ExtranetWrapper } from '../../components/extranet/ExtranetWrapper'
import { FrontpageCustomerContent } from '../../components/frontpage/FrontpageCustomerContent'
import { __EXTRANET_WRAPPER_WIDTH_PIXELS } from '../../constants'
import { useAuthenticationContext } from '../../features/authentication/useAuthentication'
import { api } from '../../services/HttpService'

const CarouselContainer = styled.div`
  width: ${__EXTRANET_WRAPPER_WIDTH_PIXELS}px;
  margin-top: var(--spacing-medium);
  margin-left: auto;
  margin-right: auto;

  @media (max-width: ${__EXTRANET_WRAPPER_WIDTH_PIXELS}px) {
    width: 100%;
  }
`

export const FrontpageView = () => {
  const { user } = useAuthenticationContext()
  const { maxMobile } = useBreakpoint()

  const { t } = useTranslation('common')

  const { key, i18n } = useLanguage()

  const { data: bannersData } = useQuery({
    queryKey: ['__getBanners', i18n.language, BannerViewEnum.Frontpage],
    queryFn: async () =>
      await api.banners.getAllBanners({ lang: i18n.language, view: BannerViewEnum.Frontpage }),
  })

  return (
    <>
      <CarouselContainer>
        <ExtranetCarousel autoplay>
          {(bannersData || []).map((banner) => (
            <ExtranetCarouselItem key={banner.id}>
              <PharmacLink
                href={key(banner.url)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ExtranetCarouselImage
                  imageSrc={!maxMobile ? key(banner.image) : key(banner.mobileImage)}
                  imageAlt={key(banner.url)}
                />
              </PharmacLink>
            </ExtranetCarouselItem>
          ))}
        </ExtranetCarousel>
      </CarouselContainer>
      <ExtranetWrapper>
        <ExtranetContainer
          full
          flexColumn
        >
          <ExtranetContainer full></ExtranetContainer>
          <ExtranetContainer
            full
            flexRow
            alignCenter
            justifyCenter
            paddingLargeVertical
          >
            {!!user && (
              <PharmacH3 color="purple">{`${t('greeting')} ${user.firstName}!`}</PharmacH3>
            )}
          </ExtranetContainer>
          <FrontpageCustomerContent />
        </ExtranetContainer>
      </ExtranetWrapper>
    </>
  )
}
